export default __webpack_public_path__ + "assets/img/img-icon-requirement-empty.c1dcd933ba4e28a34c0f1180e8647986.svg";